import { cssVar } from 'src/app/styles/helper';
import { SpacingPropKeys } from 'src/app/styles/spacing';
import styled, { css } from 'styled-components';

const MARGIN_SIZE: Record<string, SpacingPropKeys> = {
  sm: 'spacing-xs',
  md: 'spacing-xs',
  lg: 'spacing-sm',
  xl: 'spacing-sm',
};

const BUTTON_SIDE_ICON_STYLES = {
  left: (size: keyof typeof MARGIN_SIZE) => css`
    margin-right: ${cssVar(MARGIN_SIZE[size])};
  `,
  right: (size: keyof typeof MARGIN_SIZE) => css`
    margin-left: ${cssVar(MARGIN_SIZE[size])};
  `,
};

interface ButtonSideIconProps {
  $iconPosition: 'left' | 'right';
  $size: 'sm' | 'md' | 'lg' | 'xl';
}

export const ButtonSideIcon = styled.div<ButtonSideIconProps>`
  ${({ $iconPosition, $size }) => BUTTON_SIDE_ICON_STYLES[$iconPosition]($size)}
  height: fit-content;
  display: inline-flex;
  justify-content: center;
  align-items: center;
`;

const smallButtonStyles = css`
  padding: ${cssVar('spacing-md')};
`;

const mediumButtonStyles = css`
  padding: 10px;
`;

const largeButtonStyles = css`
  padding: ${cssVar('spacing-lg')};
`;

const xLargeButtonStyles = css`
  padding: 14px;
`;

export const BUTTON_ICON_SIZE_STYLES = {
  sm: smallButtonStyles,
  md: mediumButtonStyles,
  lg: largeButtonStyles,
  xl: xLargeButtonStyles,
};
